import React, {Component} from 'react';

export class RequestorInfoCard extends Component{
    constructor(props) {
        super(props);
    }

    render(){
        return(
            <div id="Requestor-Info-Card" className="col-sm-12 col-md-6 mt-3">
                <div className="card border border-dark p-2">
                    <div className="display-5 mb-2">Your details</div>
                    <div className="row">
                        <div className="col-md-12 col-sm-9">
                            <label className="control-label">Full Name</label>                
                            <input required name="Requestor.FullName" className="form-control" autoComplete="name"/>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label className="control-label">Email Address</label>
                            <input required name="Requestor.emailAddress" className="form-control" autoComplete="email"/>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label className="control-label">Phone Number</label>
                            <input required name="Requestor.phoneNumber" className="form-control" autoComplete="home tel"/>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label className="control-label">Company Name</label>
                            <input name="Requestor.companyName" className="form-control"/>
                        </div>
                    </div>
                </div>
            </div>  
        )     
    }
   
}